import DateRangeIcon from '@mui/icons-material/DateRange';
import Man4Icon from '@mui/icons-material/Man4';
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import ClassIcon from '@mui/icons-material/Class';
import EmailIcon from '@mui/icons-material/Email';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import PublicIcon from '@mui/icons-material/Public';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import WorkIcon from '@mui/icons-material/Work';
import SavingsIcon from '@mui/icons-material/Savings';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import TranslateIcon from '@mui/icons-material/Translate';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import CloudIcon from '@mui/icons-material/Cloud';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import ExtensionIcon from '@mui/icons-material/Extension';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SchoolIcon from '@mui/icons-material/School';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import AssistWalkerIcon from '@mui/icons-material/AssistWalker';
import FastfoodIcon from '@mui/icons-material/Fastfood';

export const studentDetails = [
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'Date of Birth', key: 'dateOfBirth', icon: DateRangeIcon },
  { label: 'Gender', key: 'gender', icon: Man4Icon },
  { label: 'Blood Group', key: 'bloodGroup', icon: BloodtypeIcon },

  { label: 'Student Class', key: 'currentClassName', icon: ClassIcon },
  { label: 'Syllabus', key: 'syllabusName', icon: ClassIcon },
  { label: 'Medium', key: 'mediumName', icon: ClassIcon },
  { label: 'Admn No', key: 'admnNo', icon: ClassIcon },
  { label: 'Email', key: 'email', icon: EmailIcon },
  { label: 'Country', key: 'countryName', icon: PublicIcon },
  { label: 'City', key: 'cityTown', icon: LocationCityIcon },
  { label: 'State', key: 'stateName', icon: LocationCityIcon },
  { label: 'District', key: 'districtName', icon: LocationCityIcon },
  { label: 'Pincode', key: 'pincode', icon: PersonPinCircleIcon },
  { label: 'Landmark', key: 'landmark', icon: PersonPinCircleIcon },
  { label: 'Street', key: 'streetName', icon: PersonPinCircleIcon },
  { label: 'Post', key: 'post', icon: EmailIcon },
  { label: 'House Name', key: 'houseName', icon: OtherHousesIcon },
];
export const parentDetails = [
  { label: 'Father Name', key: 'fatherName' },
  { label: 'Father Qualification', key: 'fatherQualification', icon: HistoryEduIcon },
  { label: 'Father Occupation', key: 'fatherOccupation', icon: WorkIcon },
  { label: 'Father Annual Income', key: 'fatherAnnualIncome', icon: SavingsIcon },
  { label: 'Mother Name', key: 'motherName' },
  { label: 'Mother Qualification', key: 'motherQualification', icon: HistoryEduIcon },
  { label: 'Mother Occupation', key: 'motherOccupation', icon: WorkIcon },
  { label: 'Mother Annual Income', key: 'motherAnnualIncome', icon: SavingsIcon },
  { label: 'Guardian', key: 'guardian' },
  { label: 'Relation with Student', key: 'relationWithStudentName', icon: Diversity1Icon },
];
export const academicDetails = [
  { label: 'Trainer preference', key: 'trainerPreference', icon: Man4Icon },
  { label: 'Language fluency', key: 'languageFluency', icon: TranslateIcon },
  // { label: 'Attendance percentage', key: '' },
  { label: 'Challenges in Childs learning', key: 'learningChallenges', icon: LightbulbIcon },
  { label: 'Special Needs and learning Disabilities', key: 'specialNeedsAndLearning', icon: AccessibilityIcon },
  { label: 'School', key: 'schoolName', icon: SchoolIcon },
  { label: 'Place of School', key: 'schoolPlace', icon: CastForEducationIcon },
];

export const contactDetails = [
  { label: 'Contact No.', key: 'leadContactNumberCombined', icon: ContactPhoneIcon },
  { label: 'Whatsapp No.', key: 'whatsappNumber', icon: WhatsAppIcon },
  { label: 'Father No.', key: 'fatherContactNumberCombined', icon: ContactPhoneIcon },
  { label: 'Mother No.', key: 'motherContactNumberCombined', icon: ContactPhoneIcon },
];

export const environmentDetails = [
  { label: 'Home type', key: 'homeType', icon: OtherHousesIcon },
  { label: 'Internet', key: 'internetType', icon: CloudIcon },
];

export const sibilingsDetails = [
  { label: 'Name', key: 'name' },
  [
    { label: 'Age', key: 'age', icon: DateRangeIcon },
    { label: 'Class', key: 'class', icon: ClassIcon },
  ],
];

export const personalityDetails = [
  { label: 'Average screen time', key: 'averageScreenTime', icon: PhoneAndroidIcon },
  { label: 'Favourite Cartoon or Character', key: 'favouriteCartoonCharacter' },
  { label: 'Student Hobbies interest', key: 'studentHobbiesInterests', icon: ExtensionIcon },
  { label: 'Student Ambition', key: 'studentAmbition', icon: AutoGraphIcon },
  { label: 'Preffered type of toy', key: 'preferredTypeOfToy', icon: SmartToyIcon },
  { label: 'Parents aspiration - Child', key: 'parentsAspirationChild', icon: QueryStatsIcon },
  { label: 'Disabilities', key: 'disabilities', icon: AssistWalkerIcon },
  { label: 'Favourite Food', key: 'favouriteFood', icon: FastfoodIcon },
];
